import React from 'react'
import styles from './forgot-password-form.styles'
import injectSheet from 'react-jss'
import FormHolder from '../../../form-holder/form-holder'
import FormLabel from '../../../form-label/form-label'
import FormRow from '../../../form-row/form-row'
import FormInput from 'pobble-components/dist/form-elements/form-input'
import Button from 'pobble-components/dist/button'
import { Formik } from 'formik'
import * as Yup from 'yup'
import classNames from 'classnames'

const ForgotPasswordForm = ({ classes, onSubmit, pending }) => (
  <Formik
    initialValues={{ email: '' }}
    validationSchema={Yup.object().shape({
      email: Yup.string()
        .required('Please provide your email')
        .email('Provide valid email address please')
    })}
    onSubmit={onSubmit}>
    {({
      values,
      handleSubmit,
      handleChange,
      handleBlur,
      errors,
      touched,
      isValid
    }) => {
      return (
        <form
          onSubmit={handleSubmit}
          className={classNames({ [classes.pending]: pending })}>
          <FormHolder>
            <FormRow>
              <FormLabel htmlFor="email">Email</FormLabel>
              <FormInput
                center
                validationError={touched.email && errors.email}
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.email}
                name="email"
                type="email"
              />
            </FormRow>
            <FormRow>
              <Button
                disabled={!isValid}
                className={classes.button}
                tall
                wide
                type="submit">
                Send me reset password instructions
              </Button>
            </FormRow>
          </FormHolder>
        </form>
      )
    }}
  </Formik>
)

export default injectSheet(styles)(ForgotPasswordForm)
